import { render, staticRenderFns } from "./Telemetry.vue?vue&type=template&id=3dd5fa38&"
import script from "./Telemetry.vue?vue&type=script&lang=ts&"
export * from "./Telemetry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports